app.directive(
    'howManyMore', ['$filter', '$rootScope', '$timeout', function ($filter, $rootScope, $timeout) {
        return {
            restrict: 'A',
            scope: true,
            link: function (scope, element, attrs) {
                $(element[0]).append('<li class="tag-nb hide-tag"><span></span></li>');
                var update = function () {
                    $timeout(
                        function () {
                            var parent = $(element[0]);
                            var items = $(element[0]).find('[item]');
                            var nbItemHide = 0;

                            $.each(
                                items, function (index, item) {
                                    if (!checkOutside(parent[0], item)) {
                                        $(item).addClass('hide-tag');
                                        nbItemHide++;
                                    } else {
                                        $(item).removeClass('hide-tag');
                                    }
                                }
                            );

                            if (nbItemHide > 0) {
                                var tag = $(element[0]).find('.tag-nb');
                                tag.removeClass('hide-tag');
                                tag.find('span').text('+ ' + nbItemHide);
                            } else {
                                $(element[0]).find('.tag-nb').addClass('hide-tag');
                            }
                        }
                    )
                };
                update();
                // $rootScope.$on('windowResize', update);

                element.bind(
                    'click', function () {
                        $timeout(
                            function () {
                                update();
                            }, 300
                        )

                    }
                );

                scope.$watchGroup(
                    [
                        function () {
                            return [element[0].clientWidth, element[0].clientHeight].join('x');
                        },
                        function () {
                            return $(element[0]).find('[item]').length;
                        }
                    ]
                    ,
                    function (value) {
                        update();
                    }
                );

                function checkOutside(parentDiv, childDiv) {
                    var parentRect = parentDiv.getBoundingClientRect();
                    var childRect = childDiv.getBoundingClientRect();

                    return parentRect.left <= childRect.left && parentRect.right >= childRect.right;
                }
            }
        }
    }]
);